import { makeImperativeComponent } from '@apia/util';
import { RefreshButton } from './RefreshButton';
import { SettingsButton } from './SettingsButton';
import { TPanelProps } from '../../../types';

export const [, panelButtonsActions, PanelButtons] = makeImperativeComponent<
  Omit<TPanelProps, 'initialData' | 'children'>,
  {
    disable: boolean;
  }
>()({
  Component: (props) => {
    return (
      <>
        {props.isRefreshable && (
          <>
            <RefreshButton {...props} />
          </>
        )}
        {props.isConfigurable && <SettingsButton title={props.title} />}
      </>
    );
  },
});
